import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_document_item = _resolveComponent("document-item")!
  const _component_pdf_preview_modal = _resolveComponent("pdf-preview-modal")!
  const _component_signature_pad_modal = _resolveComponent("signature-pad-modal")!
  const _component_StatusModal = _resolveComponent("StatusModal")!
  const _component_standart_template = _resolveComponent("standart-template")!

  return (_openBlock(), _createBlock(_component_standart_template, null, {
    default: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mb-4 text-grey" }, [
        _createElementVNode("div", { class: "text-xl font-semibold" }, "Документы"),
        _createElementVNode("div", { class: "mt-1 text-sm text-grey text-opacity-50" }, " Подпишите и отправьте документы в один клик ")
      ], -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
        return (_openBlock(), _createBlock(_component_document_item, {
          key: document.id,
          document: document,
          onSign: _ctx.onSign,
          onOpen: _ctx.onOpen,
          onDownload: _ctx.onDownload,
          onSend: _ctx.onSend
        }, null, 8, ["document", "onSign", "onOpen", "onDownload", "onSend"]))
      }), 128)),
      _createVNode(_component_pdf_preview_modal, {
        state: _ctx.previewModalState,
        url: _ctx.previewDocumentUrl,
        "file-name": _ctx.previewDocumentName,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.previewModalState = false))
      }, null, 8, ["state", "url", "file-name"]),
      _createVNode(_component_signature_pad_modal, {
        state: _ctx.signModalState,
        document: _ctx.signDocument,
        onSigned: _ctx.onSigned,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.signModalState = false))
      }, null, 8, ["state", "document", "onSigned"]),
      _createVNode(_component_StatusModal, {
        type: "success",
        description: "Документ отправлен",
        "button-text": "Хорошо",
        state: _ctx.sendStatusState,
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendStatusState = false))
      }, null, 8, ["state"])
    ]),
    _: 1
  }))
}